interface SpinnerProps {
  label?: string;
  /** Fill the viewport height (for route-level Suspense fallbacks). */
  fullPage?: boolean;
}

export default function Spinner({
  label = 'Loading…',
  fullPage = false,
}: SpinnerProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center gap-3 ${
        fullPage ? 'min-h-[60vh]' : 'py-10'
      }`}
      role="status"
      aria-live="polite"
    >
      <span className="loading loading-spinner loading-lg text-primary" />
      <span className="text-sm text-base-content/60">{label}</span>
    </div>
  );
}
